import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import {
    fetchClubs,
    setClubID,
} from './../../actions/FormationActions';
import OutsideNotifier from '../../OutsideNotifier';
import ProgressBar from './ProgressBar';
import NextBtn from './NextBtn';
import common from './../../common';
import { find } from 'lodash';
import AdBottom from '../AdBottom';

class FavouriteClub extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMorePublicLeagueTooltipOpen: false,
            isMoreYourCountryLeagueTooltipOpen: false,
            isClubListExpanded: !this.props.clubID,
        };
    }

    isFooterInView = () => {
        const elem = document.querySelector('.footer-wrap');
        return common.isElementInViewport(elem);
    };
    onVisibilityChange = (callback) => {
        const _this = this;
        let old_visible;
        return function () {
            let visible = _this.isFooterInView();
            if (visible !== old_visible) {
                old_visible = visible;
                if (typeof callback === 'function') {
                    callback(visible);
                }
            }
        }
    };
    handler = this.onVisibilityChange(function (visibility) {
        if (this.nextBtn && this.dummyBtn) {
            if (visibility) {
                this.nextBtn.classList.remove('si-sticky-btn');
                this.dummyBtn.style.display = 'none';
            } else {
                this.nextBtn.classList.add('si-sticky-btn');
                this.dummyBtn.style.display = '';
            }
        }
    }.bind(this));

    componentDidMount() {
        this.props.fetchClubs();
        document.addEventListener('scroll', this.handler);
        this.handler();
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handler);
    }

    handleNext = (isNext) => {
        if (!isNext) {
            common.customTracking('Skip');
        } else {
            // common.customTracking('Name Team');
        }
        !isNext && this.props.setClubID("");
        return this.props.history.push('/save-team');
    };
    onClubSelect = (id) => {
        common.customTracking('Select Favourite Club');
        this.props.setClubID(id);
    };
    toggleListView = (e) => {
        common.customTracking('Edit Favourite Club');
        this.setState((state) => ({ isClubListExpanded: !state.isClubListExpanded }));
    };
    onMorePublicLeague = () => {
        common.customTracking('Click on ?');
        this.setState((state) => ({ isMorePublicLeagueTooltipOpen: !state.isMorePublicLeagueTooltipOpen }));
    };
    onMoreYourCountryLeagueTooltip = () => {
        common.customTracking('Click on ?');
        this.setState((state) => ({ isMoreYourCountryLeagueTooltipOpen: !state.isMoreYourCountryLeagueTooltipOpen }));
    };

    render() {
        const { teamName, clubID } = this.props;
        if (!teamName) {
            return <Redirect push to={ '/team-name' } />
        }
        const isNext = !!clubID;
        const text = isNext ? this.props.trans.next : this.props.trans.skip;
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-custom-team': true,
            'si-no-anim': true,
            'si-team-selected': true,
        });
        const morePublicLeagueClass = common.makeClasses({
            'si-info': true,
            'si-active': this.state.isMorePublicLeagueTooltipOpen
        });
        const moreCountryLeagueClass = common.makeClasses({
            'si-info': true,
            'si-active': this.state.isMoreYourCountryLeagueTooltipOpen
        });
        const clubObj = clubID ? find(this.props.clubsData.response, { Id: clubID }) : null;
        const clubName = (clubID && clubObj) ? clubObj['webName'] : null;
        const clubWrapperClass = common.makeClasses({
            'si-league-wrap': true,
            'si-club-league': true, 'si-flexBox': true,
            'si-club-selected': !this.state.isClubListExpanded
        });
        let markup = clubName || (<React.Fragment><span>{ this.props.trans['club_league'] }</span><span
            className='si-small-font'>{ this.props.trans['ucl_clubs_only'] }</span></React.Fragment>);
        return <div className={ wrapperClass }>
            <div className="si-container">
                <div className="si-top-section">
                    <ProgressBar />
                    <div className="si-heading-wrap si-flexBox">
                        <div className="si-club-heading">
                            <span className="si-title">{ this.props.trans['leagues_you_will_join'] }</span>
                            <div className="si-flexBox si-text">
                                <span>{ this.props.trans['whats_a_public_league'] }</span>
                                <div className={ morePublicLeagueClass }>
                                    <i className="icon-ucl-more_nfo" onClick={ () => this.onMorePublicLeague() } />
                                    { this.state.isMorePublicLeagueTooltipOpen ?
                                        <OutsideNotifier handler={ () => this.onMorePublicLeague() }>
                                            <div className="si-tooltip">
                                                <span>{ this.props.trans['public_leagues_are'] }</span>
                                            </div>
                                        </OutsideNotifier> : null }
                                </div>
                            </div>
                        </div>
                        <NextBtn { ...{ text } } isSecondary={ !isNext }
                            handler={ () => this.handleNext(isNext) } />
                    </div>
                </div>
                <div className="si-cust-container si-club-container si-flexBox">
                    <div className="si-league-wrap si-global-league si-flexBox">
                        <div className="si-txt-wrap si-flexBox">
                            <i className="icon-ucl-global_league" />
                            <span>{ this.props.trans['global_league'] }</span>
                        </div>
                        <i className="icon-ucl-tick" />
                    </div>
                    <div className="si-league-wrap si-country-league si-flexBox">
                        <div className="si-flexBox si-vertical-center">
                            <div className="si-txt-wrap si-flexBox">
                                <i className="icon-ucl-country_league" />
                                <span>{ this.props.trans['your_country_league'] }</span>
                            </div>
                            <div className={ moreCountryLeagueClass }>
                                <i className="icon-ucl-more_nfo"
                                    onClick={ () => this.onMoreYourCountryLeagueTooltip() } />
                                { this.state.isMoreYourCountryLeagueTooltipOpen ?
                                    <OutsideNotifier handler={ () => this.onMoreYourCountryLeagueTooltip() }>
                                        <div className="si-tooltip">
                                            <span>{ this.props.trans['league_will_depend_on'] }</span>
                                        </div>
                                    </OutsideNotifier> : null }
                            </div>
                        </div>
                        <i className="icon-ucl-tick" />
                    </div>
                    <div className={ clubWrapperClass } onClick={ (e) => this.toggleListView(e) }>
                        <div className="si-flexBox si-vertical-center">
                            <div className="si-txt-wrap si-flexBox">
                                <i className="icon-ucl-club_league" />
                                <div className="si-club-title">
                                    { markup }
                                </div>
                            </div>
                            { clubID ? <i className="icon-ucl-tick" /> : null }
                        </div>
                        <div className="si-clubs-list">
                            <Scrollbars>
                                { this.props.clubsData.response.map((club) => {
                                    const className = club.Id === clubID ? 'si-selected' : '';
                                    return <span key={ club.Id } className={ className }
                                        onClick={ () => this.onClubSelect(club.Id) }>{ club['webName'] }</span>
                                }) }
                            </Scrollbars>
                        </div>
                    </div>
                    <div className="si-league-msg">
                        <span>{ this.props.trans['able_to_create_private'] }</span>
                    </div>
                </div>
                <div className="si-btn-wrp si-dummy-btn" ref={ (ref) => this.dummyBtn = ref }>
                    <div className="si-btn"><span>TEST</span></div>
                </div>
                <div className="si-btn-wrp" ref={ (ref) => this.nextBtn = ref }>
                    <NextBtn isSecondary={ !isNext }
                        { ...{ text } }
                        handler={ () => this.handleNext(isNext) } />
                </div>
                <AdBottom />
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        clubsData: state.formationData.clubsData,
        teamName: state.formationData.teamData.teamName,
        clubID: state.formationData.teamData.clubID,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setClubID: (id) => dispatch(setClubID(id)),
        fetchClubs: () => dispatch(fetchClubs()),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FavouriteClub));


// WEBPACK FOOTER //
// ./src/components/onboarding/FavouriteClub.js